(function ($) {
	class W4D_ShopCategories {
		constructor() {
			this.variationsObserver = null;
			this.observedElements = new WeakSet();
			this.init();
		}

		init() {
			const pendingTargets = new Set();
			const debouncedVariations = this.debounce(() => {
				if (pendingTargets.size > 0) {
					const $targets = $(Array.from(pendingTargets));
					pendingTargets.clear();
					this.handleVariationOverflow($targets);
				} else if ($('.variations__list').length) {
					this.handleVariationOverflow();
				}
			}, 200);

			if ('ResizeObserver' in window) {
				this.variationsObserver = new ResizeObserver((entries) => {
					let hasChanges = false;
					entries.forEach((entry) => {
						const el = entry.target;
						const currentWidth = entry.contentRect.width;
						const lastWidth = el.dataset.w4dLastWidth ? parseFloat(el.dataset.w4dLastWidth) : null;

						if (lastWidth === null || Math.abs(currentWidth - lastWidth) > 1) {
							el.dataset.w4dLastWidth = currentWidth;
							pendingTargets.add(el);
							hasChanges = true;
						}
					});
					if (hasChanges) {
						debouncedVariations();
					}
				});
			}

			this.reinit();

			$(window).on(
				'resize',
				this.debounce(() => {
					if (!('ResizeObserver' in window) && $('.variations__list').length) {
						this.handleVariationOverflow();
					}
					if ($('.shop-categories').length) this.updateArrowOffsets();
				}, 200)
			);
		}

		observeVariations(context = document) {
			if (!this.variationsObserver) return;

			const cards =
				context === document
					? Array.from(document.querySelectorAll('.variations--card'))
					: $(context).find('.variations--card').addBack('.variations--card').toArray();

			for (let i = 0; i < cards.length; i++) {
				const el = cards[i];
				if (!this.observedElements.has(el)) {
					this.observedElements.add(el);
					this.variationsObserver.observe(el);
				}
			}
		}

		reinit(context = document) {
			if ($('.variations__list').length) {
				const $cards = $(context).find('.variations--card').addBack('.variations--card');
				this.handleVariationOverflow($cards);
				this.observeVariations(context);
			}

			if ($('.shop-categories').length) {
				this.updateArrowOffsets();
			}

			if ($('.shop-categories__list--buttons').length) {
				this.initScrollFade();
			}
		}

		updateArrowOffsets() {
			$('.shop-categories').each((i, el) => {
				const $container = $(el);
				const $titles = $container.find('.shop-categories__title');

				if (!$titles.length) return;

				let maxHeight = 0;
				$titles.each((j, title) => {
					const height = $(title).outerHeight();
					if (height > maxHeight) {
						maxHeight = height;
					}
				});

				if (maxHeight > 0) {
					// offset = max_height / 2 + 0.75rem (12px assuming 16px root)
					// The user said: "biggest height of the .shop-categories__title element ... + fixed offset .75rem"
					// and "position the .carousel__arrow to 50% - this offset calculation"
					// If the arrow should be centered vertically on the image, and the image is followed by the title,
					// then the 50% point of the whole container is between the image and title.
					// Wait, if I set --arrow-offset to (maxHeight + offset), then calc(50% - var(--arrow-offset))
					// will move the arrow UP by (maxHeight + offset) from the 50% line.

					const remInPx = parseFloat(getComputedStyle(document.documentElement).fontSize) || 16;
					const offsetPx = 0.75 * remInPx;
					const totalOffset = (maxHeight + offsetPx) / -2;

					el.style.setProperty('--arrow-offset', `${totalOffset}px`);
				}
			});
		}

		handleVariationOverflow($targetCards) {
			const $cards = $targetCards && $targetCards.length ? $targetCards : $('.variations--card');
			if (!$cards.length) return;

			const computations = [];

			// 1. Prepare DOM only for unmeasured lists
			$cards.each(function () {
				const $list = $(this).find('.variations__list');
				if (!$list.length) return;

				if (!$list.data('w4d-item-widths')) {
					$list.find('.variations__counter').remove();
					$list.find('.variations__item').show();
				}
			});

			// 2. Measure (Reads from DOM)
			$cards.each(function () {
				const $card = $(this);
				const $list = $card.find('.variations__list');
				if (!$list.length) return;

				const $items = $list.find('.variations__item');
				if (!$items.length) return;

				const listEl = $list[0];
				const listWidth = $list.width();
				if (listWidth === 0) return;

				let gap = $list.data('w4d-gap');
				if (typeof gap === 'undefined') {
					gap = parseFloat(getComputedStyle(listEl).columnGap || getComputedStyle(listEl).gap) || 4;
					$list.data('w4d-gap', gap);
				}

				const counterReserveWidth = 31 + gap;

				let itemWidths = $list.data('w4d-item-widths');
				if (!itemWidths) {
					itemWidths = [];
					$items.each(function () {
						itemWidths.push($(this).outerWidth(true));
					});
					$list.data('w4d-item-widths', itemWidths);
				}

				computations.push({
					$list,
					$items,
					listWidth,
					gap,
					counterReserveWidth,
					itemWidths,
				});
			});

			// 3. Compute logic (No DOM interaction)
			for (let i = 0; i < computations.length; i++) {
				const comp = computations[i];
				let accumulatedWidth = 0;
				let visibleCount = 0;

				for (let j = 0; j < comp.itemWidths.length; j++) {
					const itemWidth = comp.itemWidths[j];
					const addedWidth = j === 0 ? itemWidth : comp.gap + itemWidth;

					if (accumulatedWidth + addedWidth <= comp.listWidth) {
						accumulatedWidth += addedWidth;
						visibleCount++;
					} else {
						break;
					}
				}

				const totalItems = comp.itemWidths.length;
				let overflowCount = totalItems - visibleCount;

				if (overflowCount > 0) {
					if (accumulatedWidth + comp.counterReserveWidth > comp.listWidth && visibleCount > 1) {
						visibleCount--;
					}

					visibleCount = Math.max(1, visibleCount);
					overflowCount = totalItems - visibleCount;
				}

				comp.visibleCount = visibleCount;
				comp.overflowCount = overflowCount;
			}

			// 4. Apply changes (Writes to DOM)
			for (let i = 0; i < computations.length; i++) {
				const comp = computations[i];

				// We do the exact DOM manipulation needed instead of global reset
				comp.$list.find('.variations__counter').remove();

				if (comp.overflowCount > 0) {
					comp.$items.slice(0, comp.visibleCount).show();
					comp.$items.slice(comp.visibleCount).hide();
					comp.$list.append(`<li class="variations__counter">+${comp.overflowCount}</li>`);
				} else {
					comp.$items.show();
				}
			}
		}

		debounce(func, wait) {
			let timeout;
			return function (...args) {
				clearTimeout(timeout);
				timeout = setTimeout(() => {
					func.apply(this, args);
				}, wait);
			};
		}

		initScrollFade() {
			const el = document.querySelector('.shop-categories__list--buttons');
			if (!el || el.dataset.fadeInitialized) return;
			el.dataset.fadeInitialized = 'true';

			const checkScroll = () => {
				const isEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1;
				el.classList.toggle('no-fade', isEnd);
			};

			checkScroll();
			el.addEventListener('scroll', checkScroll);
		}
	}

	$(document).ready(function () {
		window.W4D_ShopCategories = new W4D_ShopCategories();
	});
})(jQuery);
